import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
    setTimeout(() => {
      el.style.transition = 'opacity 1.2s ease, transform 1.2s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 200);
  }, []);

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="overview"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a094bb422d80c7f9150cdb763984e1f5.jpg"
          alt="Bulk Ore - Global Commodities Trading"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1520]/80 via-[#0A1520]/60 to-[#0A1520]/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1520]/70 via-transparent to-[#0A1520]/50" />
      </div>

      {/* Decorative grid lines */}
      <div className="absolute inset-0 z-0 opacity-10"
        style={{
          backgroundImage: 'linear-gradient(rgba(160,160,160,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(160,160,160,0.3) 1px, transparent 1px)',
          backgroundSize: '80px 80px'
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 pt-32 pb-20">
        <div ref={titleRef}>
          {/* Main Title */}
          <h1 className="font-playfair text-5xl md:text-7xl lg:text-8xl text-white leading-[1.05] mb-6 max-w-5xl">
            <span className="block">Connecting</span>
            <span className="block text-[#A0A0A0]">Global Commodity</span>
            <span className="block">Markets</span>
          </h1>

          {/* Subtitle */}
          <p className="text-[#B0B0B0] text-lg md:text-xl max-w-2xl leading-relaxed mb-10 font-light">
            Bulk Ore is a Hong Kong-based international trading company specializing in the global sourcing and supply of metals, minerals, fertilizers, and soft commodities — serving buyers across five continents.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => handleNav('#products')}
              className="whitespace-nowrap inline-flex items-center gap-3 px-8 py-4 bg-[#4A4A4A] text-white font-semibold text-sm uppercase tracking-widest rounded-full hover:bg-[#5A5A5A] transition-all duration-300 cursor-pointer"
            >
              Explore Portfolio
              <span className="w-8 h-8 rounded-full bg-[#0A1520]/20 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm" />
              </span>
            </button>
            <button
              onClick={() => handleNav('#contact')}
              className="whitespace-nowrap inline-flex items-center gap-3 px-8 py-4 border border-white/30 text-white font-semibold text-sm uppercase tracking-widest rounded-full hover:border-[#888888] hover:text-[#CCCCCC] transition-all duration-300 cursor-pointer"
            >
              Contact Us
            </button>
          </div>
        </div>

      </div>


    </section>
  );
}
